import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=82a3f704&scoped=true"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a3f704",
  null
  
)

export default component.exports